import { gql } from '@apollo/client'

export const GET_ADMIN_SETTINGS = gql`
  query GET_ADMIN_SETTINGS {
    findManySetting(
      where: {
        name: {
          in: [
            "admin_product_description_translate_action"
            "admin_product_name_translate_action"
          ]
        }
      }
    ) {
      name
      title
      type
      value
      shopSettingId
      description
      __typename
    }
  }
`

export const UPDATE_ADMIN_SETTINGS = gql`
  mutation UpdateOneShopSetting(
    $data: ShopSettingUpdateInput!
    $where: ShopSettingWhereUniqueInput!
  ) {
    updateOneShopSetting(data: $data, where: $where) {
      id
      __typename
    }
  }
`
